import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest, HttpResponse, HttpXsrfTokenExtractor } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, firstValueFrom, from, map, throwError } from "rxjs";
import { LocalStorageService } from "./services/local-storage.service";
import { environment } from "./environment";
import JSEncrypt from 'jsencrypt';
import * as CryptoJS from 'crypto-js';

export const ApiInterceptor: HttpInterceptorFn =  (request: HttpRequest<any>, next: HttpHandlerFn) => {
    const tokenExtractor = inject(HttpXsrfTokenExtractor); 
    const localStorageInstance = inject(LocalStorageService);
    
    let authHeaderKeys : string = 'x-auth-token';  
    const openRegistrationUrl :string = 'api/um/open/international-registration';
    const openLoginUrl :string = 'api/um/open/verify-verification-code';     
    const loginUrl :string = 'api/authorization/login';    
    const otpUrl :string = 'api/authorization/otp'; 
    const resetTokenUrl :string = 'api/authorization/generateToken'; 
    const resetPasswordUrl :string = 'api/authorization/resetPassword';
    const studentRegistration:string = 'api/um/registration/student'; 
    const instituteRegistration:string = 'api/um/registration/service-hub';
    const shStudentRegistration :string= 'api/um/registration/sh/student-registration';
    const changePassword :string= 'api/authorization/change-password';    
    const jsEncrypt = new JSEncrypt();
    let isKeyLoaded :boolean =false;
    function prepareencString() : boolean {
      if(!isKeyLoaded && localStorageInstance.publicKeyString && jsEncrypt){
        jsEncrypt.setPublicKey(localStorageInstance.publicKeyString.split("\r\n").join("\r\n")); 
        isKeyLoaded = true; 
      }  
      return isKeyLoaded 
    } 
    function encryptionCrypto(message:string | any,key:any,iv:any){
      const encrypted = CryptoJS.AES.encrypt(message, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
      return encrypted;
    }    
    async function  handleAccess(req: HttpRequest<any>, next: HttpHandlerFn):Promise<any> {       
      if (req.url.includes("logout") || req.url.includes(loginUrl) || req.url.includes(otpUrl) || req.url.includes(resetTokenUrl) || req.url.includes(resetPasswordUrl)){       
        localStorageInstance.clearAll().subscribe();
      }  
      if(!isKeyLoaded){
        prepareencString();
      }
      const aesKey = CryptoJS.lib.WordArray.random(32);
      const iv = CryptoJS.lib.WordArray.random(16);

      const storeResponse = await fetch(`${environment.apiBaseUrl}no-store`,{credentials: 'include'});//.then(r => r.text());     
      const csrfToken = (tokenExtractor.getToken() || storeResponse.headers.get('x-xsrf-token')) as string;  
      const jwtToken = await firstValueFrom(localStorageInstance.get(localStorageInstance.tokenKey),{ defaultValue: null });
      let langaugeCode = await firstValueFrom(localStorageInstance.get(localStorageInstance.userLangaugeCodeKey),{ defaultValue: null });
      let currencyCode = await firstValueFrom(localStorageInstance.get(localStorageInstance.userCurrencyCodeKey),{ defaultValue: 'INR' });
      if(!currencyCode) currencyCode ='INR';
      currencyCode = currencyCode.trim().toUpperCase().toString();    
      if (req.body instanceof FormData && (req.url.includes(resetPasswordUrl) || req.url.includes(loginUrl) || req.url.includes(studentRegistration) 
        || req.url.includes(instituteRegistration)|| req.url.includes(shStudentRegistration)) || req.url.includes(changePassword) || req.url.includes(openRegistrationUrl)) {
          if(req.body.has("UserPassword")){
            const passwordValue = req.body.get("UserPassword");            
            req.body.set("UserPassword", encryptionCrypto(passwordValue, aesKey, iv));
          }

          if(req.body.has("NewPassword")){
            const NewPasswordValue = req.body.get("NewPassword");            
            req.body.set("NewPassword", encryptionCrypto(NewPasswordValue, aesKey, iv));
          }

          if(req.body.has("ConfirmPassword")){
            const confirmPasswordValue = req.body.get("ConfirmPassword");           
            req.body.set("ConfirmPassword", encryptionCrypto(confirmPasswordValue, aesKey, iv));
          } 

      }

      const keyBase64 = CryptoJS.enc.Base64.stringify(aesKey);
      const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
      
      const encryptedAESKey = jsEncrypt?.encrypt(keyBase64);
      const encryptedIVKey = jsEncrypt?.encrypt(ivBase64);

      if(!langaugeCode) langaugeCode = 'EN';

      let headerObj:any = { };
      if(req.body instanceof FormData === false) {
        headerObj['Content-Type'] = 'application/json';
      }
      if(csrfToken && typeof csrfToken!=='undefined'){
        headerObj['XSRF-TOKEN'] = csrfToken;
      }  
      if(jwtToken && typeof jwtToken!=='undefined'){
        headerObj['Authorization'] = jwtToken;
      } 
      headerObj['x-language'] = langaugeCode; 
      headerObj['x-currency'] = currencyCode;   
      headerObj['X-Encrypted-Key'] = encryptedAESKey;
      headerObj['X-Encrypted-IV'] = encryptedIVKey;
      headerObj['MERCHANT-KEY'] = environment.MERCHANT_KEY;
      if(!environment.production){
        headerObj['DEV_MODE'] = "Dev";
      } 
      headerObj['X-Domain-Key'] = environment.appDomain;// 'OLYMPIAD';
      const changedReq = req.clone({
        headers: new HttpHeaders(headerObj),
        withCredentials: true
      });
      return next(changedReq).toPromise();
    }
    let mapReponse = (event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && event.url && event.url.includes("http")) {     
          let responseBody : any =  event.body || <any>{};  
          if(event.body instanceof Blob) {
            return event;
          }   
          if(responseBody.status!='200'){             
            ////console.log('mapReponse responseBody', responseBody);        
            throw ({ //new HttpErrorResponse
              error: responseBody.message,
              headers: event.headers,
              status: responseBody.status,
              statusText: 'ERROR',
              DuplicateRecords: responseBody['DuplicateRecords'],
              url: responseBody.SampleExcelFile || event.url            
            });
          }   
          
          if((event.url.includes(loginUrl) || event.url.includes(openLoginUrl))  && responseBody.status=='200'){
            let authKey = event.headers.has(authHeaderKeys) ? event.headers.get(authHeaderKeys) : "";            
            let userResponse = responseBody.dataobject || <any>{}; 
            if(isValid(authKey)){
              localStorageInstance.set(localStorageInstance.tokenKey, authKey ?? '').subscribe(); 
            }
            if(userResponse.UserID && userResponse.UserID>0){  
              localStorageInstance.set(localStorageInstance.userKey, JSON.stringify(userResponse)).subscribe();              
            } 
            if(userResponse.UserID && userResponse.CurrencyCode){  
              localStorageInstance.set(localStorageInstance.userCurrencyCodeKey, userResponse.CurrencyCode).subscribe();              
            }     

          }
             
          
        return event;
      }
      return event;
    }
    let handleError = (errorResponse: HttpErrorResponse) => { 
      //localStorageService.delete(localStorageService.userKey).subscribe();  
      const isObject = (val:any) => val !== null && typeof val === 'object' && !Array.isArray(val);
   
      let error = errorResponse.error;
      if(errorResponse.error && Array.isArray(errorResponse.error)){
        error = errorResponse.error.join("\r\n");
      } 
      if(isObject(error)){
        error = Object.values(error).join("\r\n");
      }
      //console.log('handleError errorResponse', error, isObject(error));
      let errorResponseObj : any = { ...errorResponse, message: error, message_http : errorResponse.message};
      return throwError(errorResponseObj);    
    }
    let isValid = (value:any)=>{
      return (value && typeof value !=='undefined' && value!='' && value!='null' ) ? true : false;
    } 
    
    return from(handleAccess(request, next)).pipe(map(mapReponse),catchError(handleError));    
    
};